(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("json-graphql-server", [], factory);
	else if(typeof exports === 'object')
		exports["json-graphql-server"] = factory();
	else
		root["json-graphql-server"] = factory();
})(global, function() {
return 